import { PayeeRequirement } from "@wingspanhq/wingspan-api-sdk";

export const getPayoutMethodRequirementName = (requirement: PayeeRequirement) =>
  requirement.name || "Payout Method";
